<label for="table-complete-search" class="col-sm-auto col-form-label">Search:</label>
<div class="col-sm-auto">
    <input id="table-complete-search" type="search" class="form-control shadow-none" autocomplete="off"
           [value]="value()" (input)="value.set($any($event.target).value)"/>
</div>
